/**
 * Texts of screen E9 · History, the second tab of Positions (specs/M6-history/spec.md §4; mockup
 * `docs/06-MiniApp/Maquettes/Historique.html`).
 *
 * Provisional until Q3 (tone; French uses "tu", as in the mockups) and Q15 (EN mockups).
 * Close-reason chips and the rounded-close note are C2 reason texts (`reason.CLOSED_BY_*`,
 * `reason.PARTIAL_CLOSE_ROUNDED_TO_FULL`): one text shared with the bot (C2 R10), never here.
 * No total, period result or statistic (FXM-04 §8, spec R11): no key for one.
 */
export const historyFr = {
  loading: 'Chargement de l’historique…',
  empty: 'Aucune position fermée pour l’instant.',
  today: 'Aujourd’hui',
  yesterday: 'Hier',
  showMore: 'Voir plus',
  retry: 'Réessayer',
  hint: 'Touche une position pour revoir les messages du canal et ce que FXMate en a compris.',
};

/** Shape of the `history` section of `Messages` (derived from the French object, like Home). */
export type HistoryMessages = typeof historyFr;

/** English texts of screen E9. `HistoryMessages` makes a missing or extra key a compile error. */
export const historyEn: HistoryMessages = {
  loading: 'Loading the history…',
  empty: 'No closed position yet.',
  today: 'Today',
  yesterday: 'Yesterday',
  showMore: 'Show more',
  retry: 'Retry',
  hint: 'Tap a position to review the channel’s messages and what FXMate understood from them.',
};
